export default __webpack_public_path__ + "static/media/3409.dbaf195d.png";